import React from 'react';
import { Card, CardBody } from 'react-bootstrap';
import { Document, Page, pdfjs } from 'react-pdf';

import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface PdfViewerProps {
  pdfUrl: string;
  pageNumber?: number;
  width?: number;
  onError?: (error: Error) => void;
  className?: string;
  showCard?: boolean;
}

export const PdfViewer: React.FC<PdfViewerProps> = ({
                                                      pdfUrl,
                                                      pageNumber = 1,
                                                      width,
                                                      onError,
                                                      className,
                                                    }) => {
  const [error, setError] = React.useState<Error | null>(null);

  const handleError = (error: Error) => {
    setError(error);
    onError?.(error);
  };

  if (error) {
    return <div>Error loading PDF: {error.message}</div>;
  }

    return (
      <Card>
        <CardBody style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
          <div style={{ cursor: 'pointer' }} className={className}>
            <Document
              file={pdfUrl}
              onLoadError={handleError}
              onClick={() => window.open(pdfUrl, '_blank', 'noopener,noreferrer')}
            >
              <Page pageNumber={pageNumber} width={width} />
            </Document>
          </div>
        </CardBody>
      </Card>
    );

};
